<script setup lang="ts">
import IconProtection from '~/components/icons/responsible-gaming/IconProtection.vue'

defineOptions({
	name: 'CommitmentSection',
})

const { t: $t } = useI18n()
</script>

<template>
	<section class="bg-success-800 py-11 md:py-20 2xl:py-32">
		<div class="container space-y-11 sm:space-y-20">
			<div class="flex flex-col items-center gap-4 max-w-[738px] mx-auto">
				<IconProtection
					class="text-primary-500"
					class-icon="w-[42px] h-[42px]"
				/>
				<div class="space-y-4 text-center">
					<h2 class="text-3xl sm:text-[48px] text-neutral-50 font-semibold">{{ $t('Our Commitment to You') }}</h2>
					<p class="text-neutral-100 text-[18px] leading-6">
						{{
							$t(
								'At {platform}, we are dedicated to maintaining a transparent and positive environment. We will continue to provide the best analysis tools for your enjoyment while actively promoting the importance of conscious playing',
								{ platform: 'Luckywise360' },
							)
						}}.
					</p>
				</div>
			</div>

			<div class="max-w-[1051px] mx-auto">
				<div class="bg-success-700 border border-primary-500 rounded-xl p-2.5 sm:p-6">
					<div class="text-center text-neutral-50 sm:text-xl">
						<p>{{ $t('Remember: luck should be fun') }}.</p>
						<p class="font-semibold">{{ $t('Knowing when to stop is a win in itself') }}.</p>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>
